// extracted by mini-css-extract-plugin
module.exports = {"main":"Signin_main__2ekBS","signin_btn":"Signin_signin_btn__1W0HN"};